globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = true;

import { createApp, ref } from 'vue/dist/vue.esm-bundler.js'

import PrimeVue from 'primevue/config';

import {
  Menu as UiMenu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
  Dialog as UiDialog,
  DialogPanel
} from '@headlessui/vue'

import {
  Bars3Icon,
  BellIcon,
  XMarkIcon,
  Bars3BottomLeftIcon
} from '@heroicons/vue/24/outline'

import {
  Carousel,
  Navigation,
  Slide
} from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

function createVueApp() {
  return createApp({
    setup() {
      const sidebarOpen = ref(false)
      const topSidebarOpen = ref(false)
      return {
        sidebarOpen,
        topSidebarOpen
      }
    }
  })
}

let app = null

function mountApp(app_) {
  app_
    .component('bars3bottomlefticon', Bars3BottomLeftIcon)
    .component('bars3icon', Bars3Icon)
    .component('bellicon', BellIcon)
    .component('carousel', Carousel)
    .component('dialogpanel', DialogPanel)
    .component('menubutton', MenuButton)
    .component('menuitem', MenuItem)
    .component('menuitems', MenuItems)
    .component('navigation', Navigation)
    .component('slide', Slide)
    .component('transitionchild', TransitionChild)
    .component('transitionroot', TransitionRoot)
    .component('uidialog', UiDialog)
    .component('uimenu', UiMenu)
    .component('xmarkicon', XMarkIcon)

  app_.use(PrimeVue, { unstyled: true });

  app_.mount('#public-app')
}

document.addEventListener('DOMContentLoaded', () => {
  app = createVueApp()
  mountApp(app)
})
